import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function evaluationModuleSelector(state: IInitialState) {
	return moduleStateSelector(state).evaluationModule;
}
